module.exports = __webpack_public_path__ + "img/d7.6c2bca96.png";